export default __webpack_public_path__ + "static/Behemoth_Tek_Gate-06b63b081d4901327fd08514e17d6b3a.png";